<div
  *ngIf="isOpen"
  class="absolute top-0 right-0 h-full surface-0 shadow-4 z-5 transition-transform duration-300 w-30rem flex flex-column m-4 control-height border-round bg-bluegray-50"
  style="z-index: 20;"
>
  <ng-container #host></ng-container>
</div>
